// Generated by ReScript, PLEASE EDIT WITH CARE


var dhaka = "dhaka";

var $$default = "default";

export {
  dhaka ,
  $$default ,
  $$default as default,
}
/* No side effect */
